export const validateToken = () => {
  const token = localStorage.getItem('token');
  if (!token) {
    console.error("❌ No authentication token found");
    return false;
  }

  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      console.error("❌ Invalid token format - expected 3 parts, got:", parts.length);
      return false;
    }

    try {
      let base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
      while (base64.length % 4) {
        base64 += '=';
      }

      const payload = JSON.parse(atob(base64));
      console.log("✅ Token payload decoded:", {
        role: payload.role,
        infinityCode: payload.infinityCode,
        email: payload.employeeEmail,
        hasExp: !!payload.exp,
        exp: payload.exp ? new Date(payload.exp * 1000).toISOString() : 'none',
        isExpired: payload.exp ? (payload.exp * 1000 < Date.now()) : false
      });

      return true;
    } catch (decodeError) {
      console.error("❌ Cannot decode token payload:", decodeError);
      console.error("Token parts[1] length:", parts[1].length);
      console.error("Token parts[1] preview:", parts[1].substring(0, 50));
      return false;
    }
  } catch (error) {
    console.error("❌ Error validating token:", error);
    return false;
  }
};

export const decodeTokenPayload = () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) return null;
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    let base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    while (base64.length % 4) {
      base64 += '=';
    }
    const json = atob(base64);
    return JSON.parse(json);
  } catch (err) {
    console.warn('Failed to decode auth token payload for manager context', err);
    return null;
  }
};